import one from '../../assets/cssduel-refs/1.png'
import two from '../../assets/cssduel-refs/2.png'
import three from '../../assets/cssduel-refs/3.png'
import four from '../../assets/cssduel-refs/4.png'
import five from '../../assets/cssduel-refs/5.png'
import six from '../../assets/cssduel-refs/6.png'
import seven from '../../assets/cssduel-refs/7.png'
import eight from '../../assets/cssduel-refs/8.png'
import nine from '../../assets/cssduel-refs/9.png'
import ten from '../../assets/cssduel-refs/10.png'
import eleven from '../../assets/cssduel-refs/11.png'
import twelve from '../../assets/cssduel-refs/12.png'

const battle1 = [
    {
        id: 1,
        title: "Simply Square",
        img: one,
        colors: ["#5d3a3a", "#b5e0ba"]
    },
    {
        id: 2,
        title: "Carrom",
        img: two,
        colors: ["#62374e", "#fdc57b"]
    },
    {
        id: 3,
        title: "Push Buttons",
        img: three,
        colors: ["#6592CF", "#243D83", "#EEB850"]
    },
    {
        id: 4,
        title: "Ups n Downs",
        img: four,
        colors: ["#62306D", "#F7EC7D"]
    },
    {
        id: 5,
        title: "Acid Rain",
        img: five,
        colors: ["#0B2429", "#F3AC3C", "#998235"]
    },
    {
        id: 6,
        title: "Missing Slice",
        img: six,
        colors: ["#E3516E", "#F7F3D7", "#51B5A9", "#FADE8B"]
    },
    {
        id: 7,
        title: "Leafy Trail",
        img: seven,
        colors: ["#0B2429", "#F3AC3C", "#998235", "#1A4341"]
    },
    {
        id: 8,
        title: "Forking Crazy",
        img: eight,
        colors: ["#6592CF", "#060F55"]
    },
    {
        id: 9,
        title: "Tesseract",
        img: nine,
        colors: ["#222730", "#4CAAB3", "#393E46"]
    },
    {
        id: 10,
        title: "Cloaked Spirits",
        img: ten,
        colors: ["#62306D", "#F7EC7D", "#AA445F", "#E38F66"]
    },
    {
        id: 11,
        title: "Eye of Sauron",
        img: eleven,
        colors: ["#191210", "#ECA03D", "#84271C"]
    },
    {
        id: 12,
        title: "Wiggly Moustache",
        img: twelve,
        colors: ["#F5D6B4", "#D86F45"]
    }
]

export const duels = [
    battle1
]

export const starter = `<div></div>
<style>
  div {
    width: 100px;
    height: 100px;
    background: #dd6b4d;
  }
</style>

<!-- OBJECTIVE -->
<!-- Write HTML/CSS in this editor and replicate the given target image in the least code possible. What you write here, renders as it is -->

<!-- SCORING -->
<!-- The score is calculated based on the number of characters you use (this comment included :P) and how close you replicate the image. Read the FAQS (https://cssbattle.dev/faqs) for more info. -->

<!-- IMPORTANT: remove the comments before submitting -->`